const dlsGray03 = {
  "color": "#c8c9c7 !important",
  "fill": "#c8c9c7 !important"
};

export { dlsGray03 };
